export default __webpack_public_path__ + "static/media/8-color.7376443d.svg";